import store from "@/store.js";

export default function msg(text, type = '', icon, close = true) {
    store.dispatch("showSnackbar", {
        type,
        text,
        icon,
        close
    })
}